<template>
  <modal :fullscreen="true" :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edycja' : 'Dodaj ustawienie' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.code">
            <v-text-field name="code" label="Kod ustawienia*" />
          </w-schema>
        </v-flex>

        <v-flex xs12>
          <w-select
            item-text="name"
            item-value="id"
            label="Grupa ustawienia"
            :items="settingGroups"
            :model="$schema.groupId"
          />
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.description">
            <v-textarea rows="2" label="Opis ustawienia" />
          </w-schema>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.valueType">
            <v-select label="Typ wartości" :items="valueTypes" @change="clearValue" />
          </w-schema>
        </v-flex>

        <v-flex v-if="$schema.valueType.$value == 'BOOLEAN'" xs12>
          <w-schema :model="$schema.value">
            <v-radio-group>
              <v-radio label="Fałsz" value="false" />

              <v-radio label="Prawda" value="true" />
            </v-radio-group>
          </w-schema>
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'NUMBER'" xs12>
          <w-schema :model="$schema.value">
            <v-text-field type="number" name="value" label="Wartość ustawienia" />
          </w-schema>
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'STRING'" xs12>
          <w-schema :model="$schema.value">
            <v-textarea rows="2" label="Wartość ustawienia" />
          </w-schema>
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'LIST' && show" xs12>
          <list-json key="LIST" :schema="$schema.value" />
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'MEDIA_ID' && show" xs12>
          <media :schema="$schema.value" />
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'JSON'" xs12>
          <CodeEditor lang="json" :model="$schema.value" />
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'CSS'" xs12>
          <CodeEditor lang="css" :model="$schema.value" />
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'HTML'" xs12>
          <html-editor :schema="$schema.value" :code-editor="true" />
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'CATEGORIES' && show" xs12>
          <entity-list :schema="$schema.value" module-name="categories" />
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'HEX'" xs12>
          <color-picker :model="$schema.value" />
        </v-flex>

        <v-flex v-else-if="$schema.valueType.$value == 'SOCIAL_MEDIA' && show" xs12>
          <list-json key="SOCIAL_MEDIA" :schema="$schema.value" :fields="socialMediaFields" />
        </v-flex>

        <v-flex v-else xs12>
          <w-schema :model="$schema.value">
            <v-text-field name="value" label="Wartość ustawienia" />
          </w-schema>
        </v-flex>
      </v-layout>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { SettingValueType, SettingValueTypeTranslation } from '@witkac/kartamiejska-shared';
import { schemaMixin, WSchema, WSelect } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import HtmlEditor from '@/components/forms/HtmlEditor';
import CodeEditor from '@/components/forms/CodeEditor';
import ColorPicker from '@/components/forms/ColorPicker';
import entityList from '@/components/forms/entityList';
import ListJson from '@/components/forms/ListJSON';
import Media from '@/components/forms/Media';
import Modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/setting.schema';
import { tryParseInt } from '@/utils';

function emptyData() {
  return {
    code: '',
    description: '',
    entityType: '',
    entityId: '',
    value: '',
    valueType: '',
    groupId: parseInt(this.$router.currentRoute.params.id) || 0
  };
}

// @vuese
// Modal dodawania ustawienia
// @group Settings
export default {
  components: { Modal, WSchema, WSelect, CodeEditor, ListJson, Media, ColorPicker, entityList, HtmlEditor },
  mixins: [schemaMixin, notificationsMixin, manageMixin('settings', {}, emptyData)],
  schema,
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      valueTypes: this.getValueTypes(),
      socialMediaFields: [
        { name: 'name', header: 'Nazwa', required: true },
        { name: 'link', header: 'Link', required: true },
        { name: 'icon', header: 'Ikona', required: true }
      ]
    };
  },
  computed: mapState({
    stateData(state) {
      const setting = state.settings.data;
      if (setting.group) {
        setting.groupId = setting.group.id;
      } else {
        setting.groupId = 0;
      }
      return setting;
    },
    settingGroups(state) {
      const groups = [...state.settingGroups.list];
      groups.push({ id: 0, name: 'Ogólne' });
      return groups;
    }
  }),
  methods: {
    // @vuese
    // Zwraca tablicę typów wartości
    getValueTypes() {
      return Object.keys(SettingValueType)
        .filter(item => isNaN(tryParseInt(item)))
        .map(item => ({ text: SettingValueTypeTranslation[item], value: SettingValueType[item] }));
    },
    // @vuese
    // Czyszczenie pola wartości przy zmianie typu wartości
    clearValue(val) {
      this.$schema.$setData({ value: '' });
    }
  }
};
</script>
